import { useContext } from 'react';

import { ExamEventScheduleModalContext } from './exam-event-schedule-modal-provider';

function useExamEventScheduleModal() {
  const context = useContext(ExamEventScheduleModalContext);

  if (!context) {
    throw new Error(
      'useExamEventScheduleModal must be used within a ExamEventScheduleModalProvider',
    );
  }

  return context;
}

export { useExamEventScheduleModal };
